module.exports = __webpack_public_path__ + "static/baby-yoda-bdf119a36bf6a54ea49c70582b092908.mp4";